import { useCallback, useEffect, useState } from "react";
import profileImg from "../assets/images/profile.png";
import "./dashboard.css";

import CalendarGif from "../assets/images/calendar.gif";

import BackIcon from "../assets/images/back.svg";

import { Link } from "react-router-dom";
import { useStateContext } from "../contexts/ContextProvider";

const DashboardGreeting = ({
  navHeading,
  redirectBack,
  user,
  data,
  rowData,
}) => {
  const [currentMonth, setCurrentMonth] = useState("");
  const [currentYear, setCurrentYear] = useState("");

  const { setShowMenu, getNameInitials } = useStateContext();

  const getCurrentMonth = useCallback(() => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let currentDate = new Date();
    let currentMonth = months[currentDate.getMonth()];

    let currentYear = currentDate.getFullYear();
    setCurrentYear(currentYear);
    const firstDay = `1 ${currentMonth}, ${currentYear}`;
    const lastDay = `${new Date(
      currentYear,
      currentDate.getMonth() + 1,
      0,
    ).getDate()} ${currentMonth}, ${currentYear}`;

    setCurrentMonth(`${firstDay} - ${lastDay}`);
  }, []);

  useEffect(() => {
    getCurrentMonth();
  }, [getCurrentMonth]);

  return (
    <div className="dashboard-greeting-container">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-8 col-md-6 col-11">
            <div className="navheading-flex mb-3">
              <div className="mobile-menu" onClick={() => setShowMenu(true)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  className="bi bi-list"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
                  />
                </svg>
              </div>
              {redirectBack && (
                <>
                  <Link to={redirectBack}>
                    <img src={BackIcon} alt="" />
                  </Link>
                </>
              )}
              {navHeading === "Leave Details HR" ? (
                <>
                  <div className="profile">
                    <div className="profile-icon">
                      <span>
                        <img src={data.profile} width={50} alt="" />
                      </span>
                    </div>
                    <div className="profile-info">
                      <span className="name">{data.empName}</span>
                      <span className="code">ID: {data.empid}</span>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="navheading">
                    <div className="navheading-main">
                      <h4>{navHeading}</h4>
                      {navHeading === "Help Desk Issues" ? (
                        <>
                          <svg
                            width="26"
                            height="26"
                            viewBox="0 0 26 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.87891 9.4954C9.12561 8.7352 9.5779 8.05815 10.1855 7.53891C10.793 7.01965 11.5321 6.67876 12.3214 6.55352C13.1108 6.42828 13.92 6.52386 14.6585 6.82955C15.3969 7.13524 16.0357 7.6393 16.5057 8.28581C16.9755 8.93231 17.2576 9.69592 17.3204 10.4927C17.3833 11.2894 17.224 12.0879 16.8612 12.8C16.4984 13.5122 15.9465 14.1105 15.2649 14.5282C14.5835 14.9458 13.7998 15.1669 13.0007 15.1669V16.2498M13.0546 20.5833V20.6917L12.9467 20.6919V20.5833H13.0546Z"
                              stroke="#000000"
                              stroke-width="1.8"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </>
                      ) : navHeading === "Grievances" ? (
                        <>
                          <svg
                            width="26"
                            height="26"
                            viewBox="0 0 26 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11.3756 9.75024C11.3756 11.246 10.5268 12.4586 9.47979 12.4586C8.43278 12.4586 7.58398 11.246 7.58398 9.75024L9.75064 7.06934C10.6694 7.25708 11.3756 8.38583 11.3756 9.75024ZM14.6256 9.75024C14.6256 8.38583 15.3319 7.25708 16.2506 7.06934L18.4173 9.75024C18.4173 11.246 17.5685 12.4586 16.5215 12.4586C15.4744 12.4586 14.6256 11.246 14.6256 9.75024ZM9.47979 16.2502H15.4381C16.186 16.2502 16.7923 16.8565 16.7923 17.6044C16.7923 18.3523 16.186 18.9586 15.4381 18.9586H9.47979C8.73192 18.9586 8.12564 18.3523 8.12564 17.6044C8.12564 16.8565 8.73192 16.2502 9.47979 16.2502ZM19.2298 17.3062C17.334 16.7919 19.0493 13.7133 18.959 11.9169C21.1256 14.5978 21.6673 17.3336 19.2298 17.3062Z"
                              fill="#000000"
                            />
                          </svg>
                        </>
                      ) : (
                        <>
                          <img
                            className="calendargif"
                            src={CalendarGif}
                            width={24}
                            alt=""
                          />
                        </>
                      )}
                    </div>
                    {navHeading === "Leave Details" ? (
                      <>
                        <div className="current-month">
                          Leave Application -{" "}
                          <strong>{rowData?.empName}</strong>
                        </div>
                      </>
                    ) : navHeading === "Leave Reconcile Details" ? (
                      <>
                        <div className="current-month">
                          Leave Application - <strong>{rowData?.name}</strong>
                        </div>
                      </>
                    ) : navHeading === "Holiday Shift Details" ? (
                      <>
                        <div className="current-month">
                          Holiday Shift Request -{" "}
                          <strong>{rowData?.name}</strong>
                        </div>
                      </>
                    ) : navHeading === "Leave Overview" ||
                      navHeading === "Company Policies" ||
                      navHeading === "Company Hierarchy" ? (
                      <>
                        <div className="current-month">{currentYear}</div>
                      </>
                    ) : navHeading === "Holiday List" ||
                      navHeading === "Help Desk Issues" ||
                      navHeading === "Grievances" ? (
                      <></>
                    ) : navHeading === "Employee Leave History" ? (
                      <>
                        <div className="current-month">
                          <strong>{rowData?.name}</strong>
                        </div>
                      </>
                    ) : (
                      <div className="current-month">{currentMonth}</div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="col-lg-4 col-md-6 col-1">
            <div className="navprofile">
              <div className="dashboard-profile-container">
                {/* <div className="notify">
                  <img src={NotifyIcon} alt="" />
                  <div className="notify-count">
                    <span>0</span>
                  </div>
                </div> */}

                <div className="profile">
                  {user?.profile ? (
                    <img src={profileImg} width={40} alt="profileImg" />
                  ) : (
                    <>
                      {user?.role === "1" ? (
                        <div className="circle">
                          <span>HR</span>
                        </div>
                      ) : (
                        <div className="circle">
                          <span>{getNameInitials(user?.userName)}</span>
                        </div>
                      )}
                    </>
                  )}

                  <div className="profile-info">
                    <div className="name">
                      <span>{user?.userName}</span>
                    </div>
                    <div className="designation">
                      <span>{user?.designation}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardGreeting;
